export const CONTENT_WIDTH = "1360px";
